import React, { useState, type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  COLLAPSIBLE_TRIGGER_VARIANT_LIGHT,
  Collapsible,
  CollapsibleTrigger,
  Flex,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  SPACING_16,
  SPACING_32,
  SpacingVertical,
} from 'mailup-web-components'

import Divider from 'Components/Divider'

import InputAddToGroup from 'Pages/RecipientsList/components/modals/bulkRemoveFromGroups/InputAddToGroup'
import InputRandom from 'Pages/RecipientsList/components/modals/bulkRemoveFromGroups/InputRandom'
import InputRemoveFromGroups from 'Pages/RecipientsList/components/modals/bulkRemoveFromGroups/InputRemoveFromGroups'

/*


import InputSetAsTest from 'Pages/RecipientsList/components/modals/bulkRemoveFromGroups/InputSetAsTest'
*/

import {
  modalBulkRemoveFromGroupsCanSubmitState,
  modalBulkRemoveFromGroupsSelectedCountState,
  modalBulkRemoveFromGroupsState,
} from 'Pages/RecipientsList/recoil/state/modals'

import {
  modalBulkRemoveFromGroupsCancelCallback,
  modalBulkRemoveFromGroupsConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalBulkRemoveFromGroups'

const ModalBulkRemoveFromGroups: FC = () => {
  const intl = useIntl()

  const [collapsedOptions, setCollapsedOptions] = useState(true)

  const { show } = useRecoilValue(modalBulkRemoveFromGroupsState)
  const canSubmit = useRecoilValue(modalBulkRemoveFromGroupsCanSubmitState)
  const count = useRecoilValue(modalBulkRemoveFromGroupsSelectedCountState)

  const handleCancel = useRecoilCallback(
    modalBulkRemoveFromGroupsCancelCallback,
    [],
  )
  const handleConfirm = useRecoilCallback(
    modalBulkRemoveFromGroupsConfirmCallback,
    [],
  )

  const handleToggleCollapedOptions = (): void => {
    setCollapsedOptions((prev) => !prev)
  }

  return (
    <Modal
      show={show}
      onClose={handleCancel}
      data-mu-test="modal-bulk-remove-from-groups"
      closeOnOverlayClick
      showClose
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.RecipientsList.ModalBulkRemoveFromGroupsTitle',
        })}
      />

      <ModalBody>
        <InputRemoveFromGroups />

        <SpacingVertical variant={SPACING_32} />
        <Divider margin="0px" />
        <SpacingVertical variant={SPACING_16} />
        <CollapsibleTrigger
          collapsed={collapsedOptions}
          onChange={handleToggleCollapedOptions}
          variant={COLLAPSIBLE_TRIGGER_VARIANT_LIGHT}
          data-mu-test="modal-add-to-group__adv-options__trigger"
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.AdvancedOptions' })}
        </CollapsibleTrigger>
        <Collapsible collapsed={collapsedOptions}>
          <Flex flexDirection="column" gap="16px" padding="16px 0 16px 16px">
            <InputAddToGroup />
            {/* 
            <InputRemoveFromGroups />
            
            <InputSetAsTest />
            */}
            <InputRandom />
          </Flex>
          <Divider margin="0px" />
        </Collapsible>
        {collapsedOptions && <SpacingVertical variant={SPACING_16} />}
      </ModalBody>

      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test="confirm"
          onClick={handleConfirm}
          disabled={!canSubmit}
        >
          {intl.formatMessage(
            { id: 'Load.RecipientsList.ActionBulkRemoveFromGroups' },
            {
              count,
            },
          )}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalBulkRemoveFromGroups
